import React from 'react'
import PropTypes from 'prop-types'
import { Form, Select } from 'antd'
import css from '../../common/Form.css'

const { Option, OptGroup } = Select

const filterOption = (input, option) =>
  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

const CrmAdAccounts = ({ onChange, value, adAccounts }) => {
  const fbAdAccounts = adAccounts.filter(account => account.lead_source_id === 3)
    .sort((a, b) => a.id - b.id)
  const googleAdAccounts = adAccounts.filter(account => account.lead_source_id === 2)
    .sort((a, b) => a.id - b.id)

  const fbOptions = fbAdAccounts.map(account => (
    <Option key={account.id} value={account.id}>
      {`${account.id} - ${account.name} -  ${account.external_id}`}
    </Option>
  ))

  const googleOptions = googleAdAccounts.map(account => (
    <Option key={account.id} value={account.id}>
      {`${account.id} - ${account.name} -  ${account.external_id}`}
    </Option>
  ))

  return (
    <div className={css.formGroup}>
      <h3>CRM Ad Account Information</h3>
      <Form.Item label="Ad Accounts" className={css.itemLabel} key="adAccountIdsForPractice">
        <Select
          mode="multiple"
          showSearch
          filterOption={filterOption}
          placeholder="Select Ad Accounts"
          onChange={val => onChange({ target: { value: val, name: 'adAccountIdsForPractice' } })}
          value={value}
          name="adAccountIdsForPractice"
        >
          <OptGroup label="Facebook">
            {fbOptions}
          </OptGroup>
          <OptGroup label="Google">
            {googleOptions}
          </OptGroup>
        </Select>
      </Form.Item>
    </div>
  )
}

CrmAdAccounts.propTypes = {
  onChange: PropTypes.func.isRequired,
  adAccounts: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.arrayOf(PropTypes.number),
}

CrmAdAccounts.defaultProps = {
  adAccounts: [],
  value: [],
}

export default CrmAdAccounts



// WEBPACK FOOTER //
// ./src/AddPractice/Products/CrmAdAccounts.js